export default __webpack_public_path__ + "static/media/SocialRight.a3101f0e.svg";